<template>
	<div
		class="select-container"
		@click.self="isOpen = !isOpen"
		@blur="isOpen = false"
		tabindex="0"
		:class="{
			'active' : isOpen,
			'up' : pullUp
		}"
	>
		<div class="select-label">
			<slot name="selected" :value="value">
				<p>
					{{ value.map(i=>i[itemText]).join( isMultiple? ', ' : '') }}
				</p>
			</slot>

			<input
				type="text"
				tabindex="-1"
				class="dropdown-search"
				:placeholder="value.length > 0 ? '' : placeholder"
				:readonly="!isSearchable"
				@input="search($event)"
				v-model="searchValue"
			>
		</div>

		<div
			class="dropdown-container"
			v-on:scroll="handleScroll"
			v-if="isOpen"
		>

			<ul v-if="items.length > 0 && !isLoading" ref="selectList">
				<li
					v-if="placeholder"
					class="item label"
					@click="selectItem(null)"
				>
					{{ placeholder }}
				</li>

				<li
					v-for="(item,index) in items"
					:class="{
						'selected' :  value.filter(i=>i[itemKey] === item[itemKey]).length > 0,
					}"
					:key="index"
					@click="selectItem(item)"
				>
					<input type="checkbox" v-if="isMultiple" :checked="value.filter(i=>i[itemKey] === item[itemKey]).length > 0">

					{{ item[itemText] || item[itemKey] }}
				</li>
			</ul>

			<span class="no-results" v-else>
				{{ !isLoading ? 'No results found.' : 'Searching ...' }}
			</span>
		</div>
	</div>
</template>
<script>
export default {
	props: {
		placeholder: {
			type: String,
			default: ''
		},

		value: {
			type: Array,
			default: () => []
		},

		items: {
			type: Array,
			default: () => []
		},

		itemKey: {
			type: String,
			default: 'id'
		},

		itemText: {
			type: String,
			default: 'text'
		},

		isSearchable: {
			type: Boolean,
			default: false
		},

		isMultiple: {
			type: Boolean,
			default: false
		},

		isLoading: {
			type: Boolean,
			default: false
		},

		pullUp: {
			type: Boolean,
			default: false
		}
	},

	data () {
		return {
			isOpen: false,
			searchValue: ''
		}
	},

	methods: {
		selectItem (item) {
			let selectedItem = []

			if (item) {
				selectedItem = [...this.value]
				let index = selectedItem.map(i => i[this.itemKey]).indexOf(item[this.itemKey])

				if (index === -1) {
					if (!this.isMultiple) selectedItem = []

					selectedItem.push(item)
				} else {
					selectedItem.splice(index, 1)
				}
			}

			this.$emit('input', selectedItem)
			this.searchValue = ''
		},

		search (e) {
			this.isOpen = !!e.target.value

			this.$emit('search', this.searchValue)
		},

		handleScroll () {
			let e = event.target
			if (e.scrollTop + e.offsetHeight + 50 >= e.scrollHeight && !this.isLoading) {
				this.$emit('loadMore')
			}
		}
	}
}
</script>
<style lang="scss" scoped>
.select-container {
	width: 100%;
	font-size: 1em;
	min-height: 2.3em;
	border: 1px solid #d0d0df;
	border-radius: 5px;
	cursor: pointer;
	position: relative;

	.select-label {
		display: flex;
		justify-content: flex-start;
		flex-wrap: wrap;
		pointer-events: none;
		user-select: none;
		align-items: center;
		padding: 5px;

		input {
			border: none;
			pointer-events: all;
			flex: 1 1 auto;

			&:read-only {
				pointer-events: none;
				user-select: none;

				&::placeholder {
					color: #777;
				}
			}
		}

		&:after {
			content: '';
			display: inline-block;
			border-top: 2px solid #7A7D7E;
			border-right: 2px solid #7A7D7E;
			height: 5px;
			width: 5px;
			transform: rotateZ(135deg);
			pointer-events: none;
			margin-bottom: 2px;
			margin-right: 10px;
		}

	}

	.dropdown-container {
		border-radius: 5px;
		margin-top: 10px;
		width: 100%;
		position: absolute;
		top: 100%;
		left: 0;
		border: 1px solid #DAD2D2;
		background: #fff;
		overflow: hidden;
		max-height: 400px;
		overflow-y: auto;
		z-index: 9;

		ul {
			width: 100%;
			height: 100%;
			list-style-type: none;

			li {
				padding: 10px;
				list-style-type: none;
				transition: 0.3s;
				user-select: none;

				&.label {
					color: #A1A1A1;
				}

				&.selected , &:hover {
					background-color: #eee;
				}

				&.hide {
					display: none;
				}

				input[type=checkbox] {
					margin-right: 10px;
					display: none;
				}
			}
		}

		.no-results {
			width: 100%;
			display: block;
			text-align: center;
			padding: 20px;
		}
	}

	&.active,
	&:focus,
	&.active .dropdown-container,
	&:focus .dropdown-container {
		outline: none;
		border-color: #2DC4B6;
	}

	&.up {
		.select-label {
			&:after {
				transform: rotateZ(-45deg);
				margin-bottom: 0;
				margin-top: 2px;
			}
		}

		.dropdown-container {
			top: unset;
			bottom: 100%;
			margin-top: 0;
			margin-bottom: 10px;
		}
    }
}
</style>
